// import Marquee from 'react-fast-marquee';
import { Image } from '../../../../components/Image/Image';
import { Title } from '../../../../components/Title/Title';
import styles from './Ticker.module.scss';
import { useCurrency } from '../../../../providers/CurrencyProvider/useCurrency';
import { getCurrencySymbol } from '../../../../services/getCurrencySymbol';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
export const Ticker =({content})=>{
    const {currency} = useCurrency();
    const currencySymbol = getCurrencySymbol(currency);
  if(!content) return;
  const {title,peoples} = content;
  const swiperProps = {
    spaceBetween: 10,
    slidesPerView: "auto",
    className: styles.list,
    modules: [Autoplay],
    speed:2000,
    autoplay: { delay: 3000, disableOnInteraction: false },
    centeredSlides:false,
    centerInsufficientSlides:false,
    loop: true,
  };
  return (
    <div className={styles.ticker}>
      {title && <Title className={styles.title} dangerouslySetInnerHTML={{ __html:title }} />}
        <Swiper {...swiperProps} >
          {peoples.map((item, index) => {
            return (
              <>
                <SwiperSlide key={index} className={styles.item}>
                  {item?.img && <Image src={item.img} className={styles.img}/>}
                  <div className={styles.user}>{item.user && item.user} {currencySymbol} {item.price && item.price}</div>
                </SwiperSlide>
              </>
            )
          })}
        </Swiper>
    </div>
  )
}